import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    SEND_SUPPORT_REQUEST: (data) => ({ data }),
    API: {
      SEND_SUPPORT_REQUEST: apiResourceActionCreator('support')
    }
  }
})

export const apiAction = (authToken, data) => commonApiActions.authenticated.post(`${USER_RESOURCE_ENDPOINT(RESOURCES.Support)}`, authToken, data, actions.user.api.sendSupportRequest)

export function* sendSupportRequest(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload.data));
  }
}

const configuration = {
  name: 'sendSupportRequest',
  action: actions,
  sagas: sendSupportRequest,
  reducers: {}
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/sendSupportRequest.js